import dayjs from 'dayjs';

import {
  Icons,
  mergeSx,
  SxProps,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type ModifiedDateProps = {
  testId: string;
  date?: string;
  sx?: SxProps;
};

export const ModifiedDate = ({
  date,
  sx,
  testId = 'modified-date',
}: ModifiedDateProps) => {
  if (!date) {
    return null;
  }

  const dateString = dayjs(date).format('MMMM DD, HH:mm');
  return (
    <Stack
      direction="row"
      height="max-content"
      gap="4px"
      alignItems="center"
      p="4px 8px"
      color={tokens.theme.fg.structural.secondary}
      bgcolor={tokens.theme.bg.structural.page}
      sx={mergeSx(
        {
          border: tokens.theme.border.structural.neutral,
          borderRadius: '4px',
        },
        sx
      )}
    >
      <Icons.ArrowsClockwise color={tokens.theme.fg.structural.secondary} />
      <Typography variant="P12R" color="inherit" data-testid={testId}>
        {dateString}
      </Typography>
    </Stack>
  );
};
